import {NgModule} from "@angular/core";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {ShareModule} from "@share/share.module";
import {ParametreMobiliteComponent} from "./parametre-mobilite.component";
import {MobiliteParametresComponent} from "./mobilite-parametres/mobilite-parametres.component";
import {DroitAdmin} from "@core/security/droit-admin";
import {MobileConfigService} from "@services/admin/parametre/mobilite/mobile-config.service";

export const parametreMobiliteRoutes : Routes = [
    {
        path: 'Parametres',
        component: MobiliteParametresComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_CONFIG_MOBILE] }
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Parametres'
    }, {
        path: '**',
        redirectTo: 'Parametres'
    }
];

@NgModule({
    imports: [ShareModule],
    declarations: [
        ParametreMobiliteComponent,
        MobiliteParametresComponent
    ],
    exports: [
        MobiliteParametresComponent
    ],
    providers: [MobileConfigService]
})
export class ParametreMobiliteModule {}
